import { getApiErrorMessage } from "shared/utils";
import type { ApiError } from "shared/utils";

const FALLBACK_MESSAGES: Record<number, string> = {
  401: "Invalid code. Please try again.",
  410: "This code has expired. Please log in again.",
  429: "Too many attempts. Please wait before trying again.",
};

const DEFAULT_MESSAGE = "Verification failed. Please try again.";

export const getVerifyError = (error: ApiError): string | null =>
  getApiErrorMessage(error, FALLBACK_MESSAGES, DEFAULT_MESSAGE);
